module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('g', [(_vm.name) ? _c('rect', {
    staticClass: "border",
    class: _vm.classRect,
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "rx": _vm.cellRadius,
      "width": _vm.cellWidth,
      "height": _vm.cellHeight
    },
    on: {
      "click": function($event) {
        _vm.consoleLog(_vm.name)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('text', {
    staticClass: "name",
    attrs: {
      "x": _vm.x,
      "y": _vm.y,
      "dx": _vm.txtDx,
      "dy": _vm.txtDy
    }
  }, [_vm._v(_vm._s(_vm.name))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51836015"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HarmapCell.vue
// module id = 99
// module chunks = 1